<template>
    <div class="nonmember" v-if="contShow">
        <div class="topCeng">
            <van-button round type="primary" size="normal" @click="open" style="padding:0px 1.2rem;font-weight:bold;color:#905C1E;border:0px;background: linear-gradient(313deg, #D5AD7E 0%, #FFDDA9 100%);">开通雅昌会员</van-button>
            <div class="men_world">该直播仅雅昌会员可观看</div>
            <van-button round type="primary" size="small" style="padding:0px 0.8rem;" @click="back">返回</van-button>
        </div>
    </div>
</template>

<script>
export default {
    props:["nonmemberShow","isLogin"],
    data() {
        return {
            contShow: this.nonmemberShow, //显示
        };
    },
    methods: {
        nonmemberFun(show){
            this.contShow=show;
        },
        //返回上一层
        back(){
            //this.$router.go(-1);
            this.$router.push({path: '/live', query: {}});
        },
        //开通雅昌会员
        open(){
            if(this.isLogin==0){
                 window.location.href = '//passport.artron.net/login?appId=1&redirect=' + encodeURIComponent(window.location.href)
            }else{
                 window.location.href='https://artexpress.artron.net/servicesd/member/detail'
            }
             
           
            //this.$parent.gotoApp();
        },
    },
};
</script>

<style>
.nonmember{
    width:100%;
    height:100%;
    /* background:url('../../../assets/img/bg.png'); */
    background:rgba(0,0,0,1);
    position:absolute;
    top:0px;
    left:0px;
    z-index:99999;
    text-align:center;
}
.topCeng{
    margin-top:50%;
}
.men_world{
    line-height:1rem;
    margin:1rem 0rem 1.2rem;
    color:#ECECEC;
    font-size:0.8rem;
}
</style>